// extracted by mini-css-extract-plugin
export var activityContainer = "_kv-0";
export var typingIndicatorContainer = "_kv-1";
export var typingIndicatorDot = "_kv-2";
export var wave = "_kv-3";